import React from "react";
export function Footer() {
  return <footer className="bg-ink px-5 pb-32 pt-10 text-center" data-id="element-159" data-mp="19ivlq3plplne">
      <p className="font-serif text-xl font-black text-white" data-id="element-160" data-mp="208cbv2p7r3oi">Reflexology 360°™</p>
      <p className="mt-2 text-sm text-white/60" data-id="element-161" data-mp="2f4ju3xh29v15">© 2026 · Elly Delgado · All Rights Reserved.</p>
      <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-white/50" data-id="element-162" data-mp="2a608jy6dql9b">
        Educational material only. REFLEXOLOGY 360°™ does not replace professional education, medical diagnosis, medical
        treatment, or healthcare advice.
      </p>
    </footer>;
}